var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"loader"})])
}]

export { render, staticRenderFns }